import * as React from 'react';
import { observer } from 'mobx-react';
import { LineItemsViewModel } from './line-items-view-model';
import { FormControl } from '../../components/form-control/form-control';
import { SelectField } from '../../components/form-fields';
import * as styles from './line-items.less';
import { Formatter } from '../../../Shared/utils/formatter';

import { ButtonStyle, CustomButton } from '../../primitives/button/button';
import { classNames } from '../../../Shared/utils/classnames';

import trashcanIcon from '../../assets/svg/trash.svg';
import { OriginalAmountInput } from '../../components/amount-input/original';
import { SvgIcon } from '../../components/svg-icon';
import { Text } from '../../components/text';
import { IOptionProps } from '../../primitives/select';

export { LineItemsViewModel };

const MAX_ALLOWED_LINE_ITEMS = 5;
const CURRENCY_SYMBOL = '$';

type LineItemFieldsProps = {
	vm: LineItemsViewModel;
	initialAmount: number;
	initialFundKey: string;
	emptyOption: IOptionProps;
}

type TotalAmountProps = {
	amount: number;
}
class TotalAmount extends React.Component<TotalAmountProps, {}> {

	render() {
		const formattedAmount = Formatter.formatNumberForDisplay(this.props.amount);
		return (
			<div>
				<span className={styles.lineItemsTotal}>
					<Text>Total</Text>:<span className={styles.lineItemsTotalAmount}>{`${CURRENCY_SYMBOL}${formattedAmount}`}</span>
				</span>
			</div>
		)
	}
}
@observer
export class LineItemFields extends React.Component<LineItemFieldsProps, {}> {
	render() {
		const {
			initialAmount,
			initialFundKey,
			vm: {
				fundOptions,
				initFields,
				addLineItem,
				removeLineItem,
				sortedFields,
				totalAmount,
				filteredFundOptions,
				highlightedIndex,
				firstNotDisabledFundKey,
				fundField
			},
			emptyOption,
		} = this.props;

		const hasOnlyOneFundVisible = fundOptions.length === 1;
		if (hasOnlyOneFundVisible) {
			return null;
		}

		const hasFields = Object.keys(sortedFields).length > 0;
		const hasSelectedMaxLineItems =
			(fundOptions.length === 1)
			|| (Object.keys(sortedFields).length === fundOptions.length)
			|| (Object.keys(sortedFields).length === MAX_ALLOWED_LINE_ITEMS);

		const hasInitialDefaultFund = !!fundField.DefaultOptionValue;
		const fundSelectionOptions = [
			...(!hasInitialDefaultFund ? [emptyOption] : []),
			...filteredFundOptions
		];
		const brandBgHighlightClass = 'brand-bg-highlight';

		return (
			<div>
				{Object.keys(sortedFields).map((key, index) => {
					const [numberField, fundField] = sortedFields[key];
					const lineItemText = numberField.value === 0 ? styles.inputPlaceholder : styles.inputText;

					return (
						<div className={classNames(styles.lineItem, highlightedIndex === index && brandBgHighlightClass)} key={key}>
							<FormControl
								className={styles.formControlFund}
								key={key}
								validationTranslationParams={fundField.getTranslationParams()}
								validationError={fundField.validationError} >
								<SelectField
									formControlId={`${index}-splitFund`}
									formField={fundField}
									options={fundSelectionOptions}
									acceptanceTestTargetId="Fund"
								/>
							</FormControl>
							<FormControl
								validationTranslationParams={numberField.getTranslationParams()}
								validationError={numberField.validationError}
								className={styles.formControlAmount}
							>
								<div className={classNames(styles.lineItemInputContainer, lineItemText)}>
									<span className={styles.currencySymbol} aria-hidden="true" role="presentation">{CURRENCY_SYMBOL}</span>
									<OriginalAmountInput
										value={numberField.value}
										dataFieldInvalid={numberField.hasValidationError}
										onChange={numberField.updateValue}
										className={styles.lineItemInput}
										acceptanceTestTargetId={`${index}-Split Amount`}
										ariaDescribedBy="amount-validation-error"
										ariaInvalid={numberField.hasValidationError}
										ariaRequired={true}
										amountIsLocked={false}
										placeholder='0.00'
									/>
								</div>
							</FormControl>
							<div className={styles.lineItemRemove}>
								<CustomButton
									className={styles.lineItemRemoveBtn}
									onClick={() => removeLineItem(key)}
									buttonStyle={ButtonStyle.Text}
									acceptanceTestTargetId="Remove-LineItem-button"
									type="button"
								>
									<span className={styles.lineItemRemoveBtnIcon}>
										<SvgIcon svg={trashcanIcon} />
									</span>
									<span><Text>Remove</Text></span>
								</CustomButton>
							</div>
						</div>
					);
				})}
				<div className={classNames(styles.lineItemsFooter, hasFields && styles.lineItemsFooterSpaceBetween)}>
					{hasFields && <TotalAmount amount={totalAmount} />}
					{!hasSelectedMaxLineItems &&
						<CustomButton
							className={styles.lineItemAddBtn}
							onClick={() => (hasFields ? addLineItem(0, hasInitialDefaultFund ? firstNotDisabledFundKey : '') : initFields(initialAmount, initialFundKey))}
							buttonStyle={ButtonStyle.Ghost}
							acceptanceTestTargetId="Add-LineItem-button"
							type="button"
							isBlocked={hasSelectedMaxLineItems}
						>
							<div className={styles.lineItemAddBtnText}>
								+ <Text>Add another fund</Text>
							</div>
						</CustomButton>
					}
				</div>
			</div>
		);
	}
}
